import { type PropsWithChildren, createContext, useContext, useEffect, useMemo } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { PerformanceAnalyticsPageStore } from 'pages/analytics/pages/performance/store/performanceAnalyticsPageStore'

const PerformanceAnalyticsPageContext = createContext<PerformanceAnalyticsPageStore | null>(null)

export const usePerformanceAnalyticsPageContext = () => {
  const context = useContext(PerformanceAnalyticsPageContext)

  if (context === null)
    throw new Error(
      'You have forgotten to wrap your root component with PerformanceAnalyticsPageProvider'
    )

  return context
}

export const PerformanceAnalyticsPageProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const store = useMemo(() => new PerformanceAnalyticsPageStore(entities), [])

  useEffect(() => {
    void store.init()

    return () => {
      store.dispose()
    }
  }, [])

  return (
    <PerformanceAnalyticsPageContext.Provider value={store}>
      {children}
    </PerformanceAnalyticsPageContext.Provider>
  )
}
